module.exports = "<div class=\"container-fluid\">\n  <img src=\"assets/images/report.png\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.html
// module id = ./src/app/reports/reports.component.html
// module chunks = main